import { render, staticRenderFns } from "./ComunicadoCreate.vue?vue&type=template&id=14cfd8d1&"
import script from "./ComunicadoCreate.vue?vue&type=script&lang=js&"
export * from "./ComunicadoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports